//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The register mode options available in the Sign-Up Register block. */
export const RegisterMode = {
    /** The logged-in user and any family members will be presented for selection. */
    Family: 0,

    /** An anonymous form (with the logged-in user pre-filled, if applicable) will be presented. */
    Anonymous: 1,

    /** The specified group's members - assuming the logged-in user belongs to the group - will be presented for selection. */
    Group: 2
} as const;

/** The register mode options available in the Sign-Up Register block. */
export const RegisterModeDescription: Record<number, string> = {
    0: "Family",

    1: "Anonymous",

    2: "Group"
};

/** The register mode options available in the Sign-Up Register block. */
export type RegisterMode = typeof RegisterMode[keyof typeof RegisterMode];
